var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.744,
    height: 19.179,
    viewBox: "0 0 18.744 19.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiling-emoticon-square-face",
    transform: "translate(31.877 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-2364.342-177.551a10,10,0,0,1-3.824-2.695,9.017,9.017,0,0,1-1.711-2.954.907.907,0,0,0,.05-.363,1.344,1.344,0,0,1,.6-.881,1.173,1.173,0,0,1,1.661.518,12.366,12.366,0,0,0,.6,1.14,7.073,7.073,0,0,0,4.076,3.109,7.717,7.717,0,0,0,7.548-1.5,7.146,7.146,0,0,0,1.862-2.539,1.618,1.618,0,0,1,.554-.725,1.191,1.191,0,0,1,1.409.155,1.279,1.279,0,0,1,.251,1.451,9.6,9.6,0,0,1-3.824,4.457,9.83,9.83,0,0,1-3.875,1.451,10.65,10.65,0,0,1-1.509.108A10.792,10.792,0,0,1-2364.342-177.551Zm-4.126-15.858a2.507,2.507,0,0,1,2.466-2.539,2.456,2.456,0,0,1,2.517,2.539,2.562,2.562,0,0,1-2.517,2.591A2.489,2.489,0,0,1-2368.469-193.409Zm13.788,2.539a2.553,2.553,0,0,1-2.466-2.591A2.55,2.55,0,0,1-2354.63-196a2.553,2.553,0,0,1,2.466,2.591,2.458,2.458,0,0,1-2.424,2.541Z",
    transform: "translate(2338 232)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeHappy);
export default __webpack_public_path__ + "static/media/be-happy.3917a55ccd8f19c7ed9c2621cd471a92.svg";
export { ForwardRef as ReactComponent };